import React, { useCallback, useEffect, useState } from "react";
import GoogleMapReact from "google-map-react";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import config from "../../config";
import moment from "moment";
import api from "../../services/api";

export default function Map() {
  const loadMarkers = async (map: any, maps: any) => {
    const group: any = localStorage.getItem("group");

    let locations: any = await api.devices([group]);
    locations = locations.data.filter(({ coordinates }: any) =>
      moment(coordinates.timestamp).add(5, "minutes").isAfter(moment().utc())
    );
    locations = locations.map(({ coordinates }: any) => ({
      lat: Number(coordinates.latitude),
      lng: Number(coordinates.longitude),
    }));

    return locations.map((position: any) => new maps.Marker({ position, map }));
  };

  const handleApiLoaded = async (map: any, maps: any) => {
    const markers = await loadMarkers(map, maps);

    const cluster = new MarkerClusterer({ markers, map });

    setInterval(async () => {
      cluster.clearMarkers();

      const markers = await loadMarkers(map, maps);

      cluster.addMarkers(markers);
    }, 5000);
  };

  const defaultProps = {
    center: {
      lat: 36,
      lng: -100,
    },
    zoom: 5,
  };

  return (
    <div style={{ height: "calc(100vh - 60px)", width: "100vw" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: config.key }}
        yesIWantToUseGoogleMapApiInternals
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        onGoogleApiLoaded={({ map, maps }) => {
          handleApiLoaded(map, maps);
        }}
        options={{
          streetViewControl: true,
          mapTypeControl: true,
        }}
      />
    </div>
  );
}
